import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-searchinput', 'clear', 'Notīrīt ievadi');
Labels.set('ui-searchinput', 'search', 'Meklēšana');
